import { QueryClient } from "@tanstack/react-query";
import { isTeamContextHandled } from "../teamContext/teamSwitchService";

// Single shared server-state cache, mounted via <QueryClientProvider> in src/index.js.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s: no refetch on remount within this window
      retry: (failureCount, error) => !isTeamContextHandled(error) && failureCount < 1,
      refetchOnWindowFocus: false, // opt in per query where it is actually wanted
    },
  },
});
